<div class="plan-social-wrapper" *ngIf="socialCapacities?.length">
  <ng-container *ngFor="let socialCapacity of socialCapacities">
    <ng-container
      *ngIf="socialCapacity.social === socialEnum.VPN; else generalSocials"
    >
      <i
        [nzTooltipTitle]="getStrPath(socialCapacity.social) | translate"
        nzTooltipPlacement="top"
        nz-tooltip
        [ngClass]="'fal fa-lock'"
      ></i>
      <div class="social-capacity" *ngIf="showCapacities">
        {{
          socialCapacity.capacity
            | utils: "convertKibByte"
            | numberFormatter: "'0.0ib'"
            | ibFix
        }}
      </div>
    </ng-container>
    <ng-template #groupedSocials>
      <i
        [nzTooltipTitle]="getStrPath(socialCapacity.social) | translate"
        nzTooltipPlacement="top"
        nz-tooltip
        [ngClass]="'fab fa-' + socialCapacity.social | lowercase"
      ></i>
      <div class="social-capacity" *ngIf="showCapacities">
        {{
          socialCapacity.capacity
            | utils: "convertKibByte"
            | numberFormatter: "'0.0ib'"
            | ibFix
        }}
      </div>
    </ng-template>

    <ng-template #remainingSocials>
      <i
        [nzTooltipTitle]="getStrPath(socialCapacity.social) | translate"
        nzTooltipPlacement="top"
        nz-tooltip
        [ngClass]="'fab fa-' + socialCapacity.social | lowercase"
      ></i>
      <div class="social-capacity" *ngIf="showCapacities">
        {{
          socialCapacity.capacity
            | utils: "convertKibByte"
            | numberFormatter: "'0.0ib'"
            | ibFix
        }}
      </div>
    </ng-template>

    <ng-template #generalSocials>
      <ng-container
        *ngIf="
          socialCapacity.social === socialEnum.FACEBOOK ||
            socialCapacity.social === socialEnum.TWITTER;
          else remainingSocials
        "
      >
        <!-- <div
          class="d-inline-block"
          nzTooltipPlacement="top"
          nz-tooltip
          [nzTooltipTitle]="getStrPath(socialCapacity.social) | translate"
        > -->
        <i
          nzTooltipPlacement="top"
          nz-tooltip
          [nzTooltipTitle]="getStrPath('FACEBOOK') | translate"
          [ngClass]="'fab fa-facebook'"
        ></i>
        <i
          nzTooltipPlacement="top"
          nz-tooltip
          [nzTooltipTitle]="getStrPath('FACEBOOK_MESSENGER') | translate"
          [ngClass]="'fab fa-facebook-messenger'"
        ></i>
        <i
          nzTooltipPlacement="top"
          nz-tooltip
          [nzTooltipTitle]="getStrPath('TWITTER') | translate"
          [ngClass]="'fab fa-twitter'"
        ></i>
        <!-- </div> -->
        <div class="social-capacity" *ngIf="showCapacities">
          {{
            socialCapacity.capacity
              | utils: "convertKibByte"
              | numberFormatter: "'0.0ib'"
              | ibFix
          }}
        </div>
      </ng-container>
    </ng-template>
  </ng-container>

  <!-- TODO: Need netflix icon -->
</div>
